import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, Typography } from 'antd';
import React, { FC } from 'react';

import { messages, MessageTypes } from '../../../../pages/Auth/messages';
import { FormFooter, FormWrapper, StepContent } from '../styled';
import { AuthType, BaseProps } from '../types';

const AuthForm: FC<BaseProps<AuthType>> = ({ initialValues, onSubmit }) => {
  const [profileForm] = Form.useForm();

  return (
    <StepContent>
      <Typography.Title level={3}>1. Set your Password</Typography.Title>
      <FormWrapper>
        <Form
          style={{ display: 'inline' }}
          form={profileForm}
          initialValues={initialValues}
          layout="vertical"
          labelCol={{ span: 12, offset: 6 }}
          wrapperCol={{ span: 12, offset: 6 }}
          onFinish={onSubmit}
        >
          <Form.Item name="email" hasFeedback label="Your email address">
            <Input
              disabled
              autoComplete="off"
              autoCapitalize="off"
              size="large"
              prefix={<UserOutlined />}
              placeholder="Enter your email"
              type="email"
            />
          </Form.Item>
          <Form.Item
            label="Provide a secure password"
            hasFeedback
            name="password"
            rules={[
              { required: true, message: messages[MessageTypes.RequiredField] },
            ]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Enter your password"
              visibilityToggle
            />
          </Form.Item>
          <Form.Item
            label="Repeat your password"
            name="confirmPassword"
            dependencies={['password']}
            hasFeedback
            rules={[
              {
                required: true,
                message: messages[MessageTypes.RequiredField],
              },
              {
                min: 8,
                message: messages[MessageTypes.PasswordLength],
              },
              ({ getFieldValue }) => ({
                validator(rule, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }

                  return Promise.reject(
                    messages[MessageTypes.IncomparablePassword]
                  );
                },
              }),
            ]}
          >
            <Input.Password
              size="large"
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password once again"
              visibilityToggle
            />
          </Form.Item>
          <FormFooter>
            <Button size="large" type="primary" htmlType="submit">
              Next
            </Button>
          </FormFooter>
        </Form>
      </FormWrapper>
    </StepContent>
  );
};

export default AuthForm;
